// src/models/attachment.ts
export type AttachmentSize = {
  source_url: string
  width?: number
  height?: number
  mime_type?: string
}

export type AttachmentSizes = {
  thumbnail?: AttachmentSize
  medium?: AttachmentSize
  large?: AttachmentSize
  full?: AttachmentSize

  // Allow dynamic sizes (hero, square, etc.)
  [key: string]: AttachmentSize | undefined
}

const attachment = (p: any) => ({
  id: p.id,
  type: p.media_type as 'image' | 'video',
  mime: p.mime_type,
  attached: p?.posts,
  alt: p?.alt_text,
  meta: p.media_details?.image_meta,
  sizes: p.media_details?.sizes as AttachmentSizes | undefined,
})

export default attachment
